"use strict";
/**
 * Logo geometry shared by the web SVG component, the React Native
 * (react-native-svg) component and the PDF/email letterheads.
 * Everything is defined on a 64×64 viewBox.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.logoText = exports.logoColors = exports.logoGeometry = exports.LOGO_VIEWBOX = void 0;
exports.logoIconSvg = logoIconSvg;
exports.LOGO_VIEWBOX = "0 0 64 64";
exports.logoGeometry = {
    /** Dashed arc above the eye. */
    arcTop: "M12 17 A 30 30 0 0 1 52 17",
    /** Dashed arc below the eye. */
    arcBottom: "M12 47 A 30 30 0 0 0 52 47",
    /** Outer eye (almond) shape. */
    eyeOutline: "M5 32 C 15.5 17.5, 48.5 17.5, 59 32 C 48.5 46.5, 15.5 46.5, 5 32 Z",
    iris: { cx: 32, cy: 32, r: 10 },
    pupil: { cx: 32, cy: 32, r: 4.5 },
    highlight: { cx: 35.2, cy: 28.8, r: 1.8 },
};
exports.logoColors = {
    outline: "#1D9E75",
    iris: "#1D9E75",
    pupil: "#0a1410",
    highlight: "#5DCAA5",
    arcs: "#0F6E56",
};
exports.logoText = {
    name: "OTZEM CHASSID",
    sub: "EYE CLINIC",
    tagline: "PRIVATE OPHTHALMOLOGY PRACTICE",
};
/**
 * Standalone SVG markup string — used for the favicon, email letterhead
 * and the prescription PDF where React is not available.
 */
function logoIconSvg(size = 64) {
    const g = exports.logoGeometry;
    const c = exports.logoColors;
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="${exports.LOGO_VIEWBOX}" width="${size}" height="${size}" fill="none">
  <path d="${g.arcTop}" stroke="${c.arcs}" stroke-width="2" stroke-dasharray="4 5" stroke-linecap="round"/>
  <path d="${g.arcBottom}" stroke="${c.arcs}" stroke-width="2" stroke-dasharray="4 5" stroke-linecap="round"/>
  <path d="${g.eyeOutline}" stroke="${c.outline}" stroke-width="2.5"/>
  <circle cx="${g.iris.cx}" cy="${g.iris.cy}" r="${g.iris.r}" fill="${c.iris}"/>
  <circle cx="${g.pupil.cx}" cy="${g.pupil.cy}" r="${g.pupil.r}" fill="${c.pupil}"/>
  <circle cx="${g.highlight.cx}" cy="${g.highlight.cy}" r="${g.highlight.r}" fill="${c.highlight}"/>
</svg>`;
}
//# sourceMappingURL=logo.js.map